<template>
<div style="display:flex; flex-direction:row">
<div style="display:flex; width:80%; flex-direction:column">
     <div style="display:flex; justify-content:space-between; width:100%">
         <button @click="returnList()"
                class="btn btn-bg btn-secondary waves-effect waves-light m-t-10 m-b-10" style="display:flex; width: 20%; margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);">
                <span class="material-icons" style="margin-right:5px">keyboard_backspace</span>  Назад
        </button>
        <button v-if="patient.conversation" @click="openVideoConf()"
            class="btn btn-bg btn-secondary waves-effect waves-light m-t-10 m-b-10" style="margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);">
            Видеозвонок
        </button>
     </div>
    <div v-if="selected_forms && selected_forms.includes(0)" class="page card" style="display:flex; justify-content:center; flex-direction: column; width:100%">
        <div style="width:auto; display:flex; justify-content:flex-start; flex-direction:column; font-size:22px; margin-bottom:5px">
            <h2>МЕДИЦИНСКАЯ КАРТА №: {{cardPatient.cardid}}</h2>
            <h3>Персональные данные пациента / <span v-if="primary_reception"> первичный осмотр </span> <span v-else>повторный осмотр </span> </h3>
            <div class="gray_field">
                <span> {{patient.last_name}} {{patient.first_name}} {{patient.middle_name}} </span>
                <label>Дата осмотра: {{date}} </label>
                <span> Врач: {{this.$store.state.auth.user.first_name }} {{this.$store.state.auth.user.last_name}}</span>
            </div>
        </div>
            <button class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10" style="border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);" @click="openCard()">Данные пациента</button>
        <cardPatient v-if="viewCardPatient" :card="cardPatient" @close="viewCardPatient = false">

        </cardPatient>
        <div v-if="primary_reception"  name="primary">
        <!--  <button class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10"
            @click="primary_reception=!primary_reception"
            >Первичный осмотр </button> 
            <h5>Первичный осмотр</h5>-->
          <div id="toggled" style="padding:0.2rem" v-bind:class="{anim: primary_reception}" >
            <div class="field">
                <textarea
                class="form-control"
                name="placeZH" id="placeZH"
                v-model="dataForm.forma['Жалобы пациента']"
                />
                <label for="placeZH">
                    24. Жалобы пациента:
                </label>
            </div>
            <div class="field">
                <textarea
                class="form-control"
                name="anamnez" id="anamnez"
                v-model="dataForm.forma['Анамнез заболевания, жизни']"
                />
                <label for="anamnez">
                    Анамнез заболевания, жизни:
                </label>
            </div>
            <div class="field">
                <textarea
                class="form-control"
                name="obdata" id="obdata"
                v-model="dataForm.forma['Объективные данные']"
                />
                <label for="obdata">
                    Объективные данные:
                </label>
            </div>
            <div class="field">
                <v-select style="width:auto; background:white;"
                :options="getDiagnoses" value=""
                :appendToBody="true"
                :reduce="opt => opt.MKB_NAME" label="MKB_NAME"
                v-model="dataForm.forma['Диагноз основного заболевания']"
                name="diagnoz" id="diagnoz"
                @keyup.native="chooseIllnes($event.target.value)"
                >
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        Не найдено: <em>{{ search }}</em>.
                    </template>
                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                </template>
                </v-select>
                <label for="diagnoz">
                    Диагноз основного заболевания:
                </label>
            </div>
            <div class="field">
                <textarea
                class="form-control"
                name="obdata" id="obdata"
                v-model="dataForm.forma['Осложнения']"
                />
                <label for="obdata">
                    Осложнения:
                </label>
            </div>
            <div class="field">
                <v-select style="width:auto; background:white"
                :options="getDiagnoses" value=""
                :appendToBody="true"
                :reduce="opt => opt.MKB_NAME" label="MKB_NAME"
                v-model="dataForm.forma['Сопутствующие заболевания']" multiple 
                name="others" id="others"
                @keyup.native="chooseIllnes($event.target.value)"
                >
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        Не найдено: <em>{{ search }}</em>.
                    </template>
                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                </template>
                </v-select>
                <label for="others">
                    Сопутствующие заболевания:
                </label>
            </div>
            <div class="field">
                <v-select style="width:auto; background:white"
                :options="getDiagnoses" value=""
                :appendToBody="true"
                :reduce="opt => opt.MKB_NAME" label="MKB_NAME"
                v-model="dataForm.forma['Внешняя причина при травмах (отравлениях)']"
                name="prichina" id="prichina"
                @keyup.native="chooseIllnes($event.target.value)"
                >
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        Не найдено: <em>{{ search }}</em>.
                    </template>
                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                </template>
                </v-select>
                <label for="prichina">
                    Внешняя причина при травмах (отравлениях):
                </label>
            </div>
            <div class="field">
                <textarea
                class="form-control"
                name="dispancer" id="dispancer"
                v-model="dataForm.forma['Диспансерное наблюдение']"
                />
                <label for="dispancer">
                    Диспансерное наблюдение:
                </label>
            </div>
            
            <!--div class="field">
                <input class="form-control" v-model="dataForm.forma['Назначения (исследования, консультации)']"
                name="consult" id="consult" />
                <label for="consult">Назначения (исследования, консультации):</label>
            </div>
            <div class="field">
                <input class="form-control" v-model="dataForm.forma['Лекарственные препараты, физиотерапия']"
                name="recept" id="recept" />
                <label for="recept">Лекарственные препараты, физиотерапия:</label>
            </div-->
          </div>
        </div>

        <div v-if="second_is_open" name="secondary" style="margin-top:5px">
       <!-- <div id="toggled" style="padding:0.2rem" v-bind:class="{anim: second_is_open}"> 

            <h5>Повторный осмотр</h5>-->
            <div class="field">
                <textarea
                class="form-control"
                name="zhaloba" id="zhaloba"
                v-model="secondary_reception['Жалобы']"
                />
                <label for="zhaloba">
                    25. Жалобы:
                </label>
            </div>
            <div class="field">
                <textarea
                class="form-control"
                name="observation" id="observation"
                v-model="secondary_reception['Данные наблюдения в динамике']"
                />
                <label for="observation">
                    Данные наблюдения в динамике:
                </label>
            </div>
            <!--div class="field">
                <input class="form-control" v-model="secondary_reception['Назначения (исследования, консультации)']"
                name="research" id="research" />
                <label for="research">Назначения (исследования, консультации):</label>
            </div>
            <div class="field">
                <input class="form-control" v-model="secondary_reception['Лекарственные препараты, физиотерапия']"
                name="medicine" id="medicine" />
                <label for="medicine">Лекарственные препараты, физиотерапия:</label>
            </div-->
        </div>
        <div class="field" style="width:auto; display:flex; flex-direction:row; justify-content:space-between">
                <div style="align-self:flex-start; width:50%; margin-right:2px;">
                    <label for="groupHealth" style="align-self:center; margin-right:10px">Группа здоровья:</label>
                    <v-select style="max-width:175px; background:white;" placeholder="выбрать"
                    name="groupHealth" id="groupHealth"
                    v-model="dataForm.forma['Группа здоровья']"
                    :appendToBody="true"
                    :options="['I группа', 'II группа', 'IIIа группа', 'IIIб группа']">
                    </v-select>
                    <div style="display:flex">
                        <span> Лист назначений: </span> <!--span style="cursor:pointer;" @click="list_appointment.push({index: list_appointment.length, file: undefined})" class="material-icons outlined">add_box</span-->
                    </div>
                    <div style="display:flex; flex-direction:column; background:white; border-radius:5px; padding:5px; margin-bottom:3px"> <!-- v-for="(appoint, ind) in list_appointment" :key="ind" :index="ind"-->
                        <div style="display:flex; justify-content:space-between"><span>{{patient.last_name}} {{patient.first_name}} {{patient.middle_name}} </span> <!--span @click="list_appointment.splice(ind, 1)" style="cursor:pointer" class="material-icons">clear</span--></div>
                        <span style="margin-bottom:2rem">Дата выдачи: {{date}} </span>
                        <span>направление на анализ/исследование</span>
                        <div v-for="file in file_list" :key="file">
                            <a class="fileHref" @click="downloadFile(file)">{{file}}</a>
                        </div>
                        <b-form-file class="mt-3" v-model="files" multiple  plain style="margin-bottom:2px"></b-form-file>
                    </div>
                </div>
                <div style="align-self:flex-start; width:50%; margin-left:2px; margin-bottom:3px">
                     <div style="display:flex">
                        <span> Рецепт </span> <span style="cursor:pointer;" @click="list_prescription.push({index: list_prescription.length, 'Наименование лекарственного препарата': [], 'Дозировка': '', 'Способ применения': '', 'Продолжительность применения': ''})" class="material-icons outlined">add_box</span>
                    </div>
                    <div style="display:flex; flex-direction:column; background:white; border-radius:5px; padding:5px; margin-bottom:3px" v-for="(prescription, ind) in list_prescription" :key="ind" :index="ind">
                        <div style="display:flex; justify-content:space-between"><span>{{patient.last_name}} {{patient.first_name}} {{patient.middle_name}} </span> <span @click="list_prescription.splice(ind, 1)" style="cursor:pointer" class="material-icons">clear</span></div>
                        <span>Дата выдачи: {{date}} </span>
                        <div class="field">
                            <v-select style="width:auto; background:white;"
                            :options="getRecepts" value=""
                            :reduce="opt => opt.S_TORG_NAME" label="S_TORG_NAME"
                            v-model="prescription['Наименование лекарственного препарата']"
                            placeholder="Наименование лекарственного препарата..."
                            name="recept" id="recept"
                            @keyup.native="chooseRecept($event.target.value)"
                            >
                            <template v-slot:no-options="{ search, searching }">
                                <template v-if="searching">
                                    Не найдено: <em>{{ search }}</em>.
                                </template>
                                <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                            </template>
                            <template #option="{ S_TORG_NAME, S_FORMS }">
                                <span style="width:100%" v-b-tooltip.hover.left :title="S_FORMS">{{ S_TORG_NAME }} </span>
                                </template>
                            </v-select>
                        </div>
                        <div class="field" style="flex-direction:row">
                            <label class="backInp">
                                   Дозировка:
                            </label> 
                            <input v-model="prescription['Дозировка']" class="form-control" style="margin-top:5px; padding-left:100px" />      
                        </div>
                        <div class="field" style="flex-direction:row">
                            <label class="backInp">
                                   Способ<span style="opacity:0">_</span>применения:
                            </label> 
                            <input v-model="prescription['Способ применения']" class="form-control" style="margin-top:5px; padding-left:170px" />      
                        </div>
                        <div class="field" style="flex-direction:row">
                            <label class="backInp">
                                   Продолжительность:
                            </label> 
                            <input v-model="prescription['Продолжительность применения']" class="form-control" style="margin-top:5px; padding-left:170px" />      
                        </div>
                    </div>
                </div>
                <!--input v-model="dataForm.forma['Группа здоровья']" name="groupHealth" id="groupHealth" class="form-control" style="width:20%" />
                <label for="dispancer" style="align-self:center; text-align:end; margin-right:10px">Диспансерное наблюдение:</label>
                <input v-model="dataForm.forma['Диспансерное наблюдение']" name="dispancer" id="dispancer" class="form-control" style="width:40%" /-->
            </div>

        <div style="display:flex; flex-direction:row">
            <div style="width:60%; display:flex; flex-direction:column">
                <span class="descr">Информированное добровольное согласие на медицинское вмешательство </span>
                <span class="descr">Отказ от медицинского вмешательства</span>
                <b-button style="margin-right: 3px; background:linear-gradient(to right, #8C30DA 260px, #5C48D4); padding-bottom:0; padding-top:0; width:100%">Информированное добровольное согласие</b-button>
            </div>
            
             <div style="display:flex; width:50%">
                <b-button @click="dataForm.is_close = !dataForm.is_close" style="align-self:flex-end; 
                height:26px; margin-left:3px; background:linear-gradient(to right, #8C30DA 260px, #5C48D4); 
                padding-bottom:0; padding-top:0; width:100%">
                Составить этапный эпикриз <span v-if="dataForm.is_close" class="material-icons" style="font-size:16px">done</span>
                </b-button>
            </div>
        </div>
            <div 
            
            >
            <div id="toggled" style="padding:0.2rem" v-bind:class="{anim: dataForm.is_close}">
                <div class="field">
                    <textarea
                    class="form-control"
                    name="dinamika" id="dinamika"
                    v-model="epicrisis['Жалобы и динамика состояния']"
                    />
                    <label for="dinamika">
                        Жалобы и динамика состояния:
                    </label>
                </div>
                <div class="field">
                    <textarea
                    class="form-control"
                    name="inspections" id="inspections"
                    v-model="epicrisis['Проведенное обследование и лечение']"
                    />
                    <label for="inspections">
                        Проведенное обследование и лечение:
                    </label>
                </div>
                <div class="field">
                    <v-select style="width:auto; background:white"
                    :options="getDiagnoses" value=""
                    :appendToBody="true"
                    :reduce="opt => opt.MKB_NAME" label="MKB_NAME"
                    v-model="epicrisis['Диагноз основного заболевания']"
                    name="diagnozEP" id="diagnozEP"
                    @keyup.native="chooseIllnes($event.target.value)"
                    >
                    <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                            Не найдено: <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                    </template>
                    </v-select>
                    <label for="diagnozEP">
                        Диагноз основного заболевания:
                    </label>
                </div>
                <div class="field">
                    <textarea
                    class="form-control"
                    name="complications" id="complications"
                    v-model="epicrisis['Осложнения']"
                    />
                    <label for="complications">
                        Осложнения:
                    </label>
                </div>
                <div class="field">
                    <v-select style="width:auto; background:white"
                    :options="getDiagnoses" value=""
                    :appendToBody="true"
                    :reduce="opt => opt.MKB_NAME" label="MKB_NAME"
                    v-model="epicrisis['Сопутствующие заболевания']" multiple 
                    name="advanced" id="advanced"
                    @keyup.native="chooseIllnes($event.target.value)"
                    >
                    <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                            Не найдено: <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                    </template>
                    </v-select>
                    <label for="advanced">
                        Сопутствующие заболевания:
                    </label>
                </div>
                <div class="field">
                    <v-select style="width:auto; background:white"
                    :options="getDiagnoses" value=""
                    :appendToBody="true"
                    :reduce="opt => opt.MKB_NAME" label="MKB_NAME"
                    v-model="epicrisis['Внешняя причина при травмах (отравлениях)']"
                    name="travma" id="travma"
                    @keyup.native="chooseIllnes($event.target.value)"
                    >
                    <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                            Не найдено: <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                    </template>
                    </v-select>
                    <label for="travma">
                        Внешняя причина при травмах (отравлениях):
                    </label>
                </div>
                <div class="field">
                    <textarea
                    class="form-control"
                    name="recomend" id="recomend"
                    v-model="epicrisis['Рекомендации']"
                    />
                    <label for="recomend">
                        Рекомендации:
                    </label>
                </div>
            </div>
            </div>

            <div class="field" style="width:auto; display:flex; flex-direction:row; justify-content:flex-end">
               <button class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10" style="margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);"
                @click="print({value: {id: '025/у'}})" :disabled="disabledPrint({value: {id: '025/у'}})">Печать</button>
                <button @click="submitForm()"
                class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10" style="margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);">
                    Сохранить
                </button>
            </div>
    </div>
    <div v-for="oform in other_forms" :key="oform.value.id" class="page card" > <!--style="display:flex; justify-content:center; flex-direction: column; width:100%"-->
            <div>
                <b-button style="width:100%" variant="info" @click="openedForm(oform)"> {{oform.value.title}} <span v-if="!oform.opened" style="font-style:italic; font-size:12px">(Развернуть)</span> <span v-else style="font-style:italic; font-size:12px">(Свернуть)</span></b-button>
            </div>
            <div v-if="oform.opened">
            <form-builder
                type="gui"
                :form="oform.data"
                v-model="oform.values"
                :ref="oform.value.title"
            ></form-builder>
                <div class="field" style="width:auto; display:flex; flex-direction:row; justify-content:space-between">
                <button @click="oform.opened=false"
                    class="btn btn-bg btn-secondary waves-effect waves-light m-t-10 m-b-10" style="margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);">
                        Отмена
                </button>
                <div>
                <button class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10" style="margin-right:10px; margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);"
                @click="print(oform)" :disabled="disabledPrint(oform)">Печать</button>
                <button @click="submitForm(oform)"
                class="btn btn-bg btn-info waves-effect waves-light m-t-10 m-b-10" style="margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);">
                    Сохранить
                </button></div>
                </div>
            </div>
        </div>
        <button @click="returnList()"
                class="btn btn-bg btn-secondary waves-effect waves-light m-t-10 m-b-10" style="display:flex; width: 20%; margin-top:15px; padding: 10px 50px 10px 50px; border-radius:25px; background: linear-gradient(to right, #8C30DA, #5C48D4);">
                <span class="material-icons" style="margin-right:5px">keyboard_backspace</span>  Назад
        </button>
    </div>
    <vue-position-sticky :offsetTop="70"  style="width: 25%;">
    <div ref="asd" style="width: 100%; margin: 10px; justify-content:flex-start;" 
        v-bind:style="historyHeight1()">
        <div style="display:flex; justify-content:center"> <h5 style="text-align:center">История приема </h5> 
        <button class="vm-icon-button" @click="reverseList()">
            <i class="material-icons" v-if="updown">arrow_upward</i>
            <i class="material-icons" v-else>arrow_downward</i>
        </button>
        </div>
        <div v-bind:style="historyHeight()">
            <ul class="list-group">
                <li v-for="(record, index) in listHistory" v-bind:index="index" 
                        :key="record.id" class="list-history"
                        @click="openHistory(record, index)"
                >
                    <p> {{record['Дата приема'].split(',')[0]}} </p>
                    <p> {{record['Дата приема'].split(',')[1]}} </p>
                    <!--span>
                        Запись: {{index}}
                    </span-->

                </li>
            </ul>
        </div>
    </div>
    </vue-position-sticky>
<ReceptionHistory  v-if="isHistoryVisible"
      @close="isHistoryVisible = false; form_value=''">
        <h3 slot="header">{{listHistory[ind]['Дата приема'].split(',')[1]}} {{patient.last_name}} {{patient.first_name}} {{patient.middle_name}} </h3> 
        <!--span slot="body"> {{listHistory[ind].uuid}} </span-->
        <div slot="body"  v-if="listHistory[ind].form === false">
        <div v-for="field in Object.keys(listHistory[ind].data)"
            v-bind:key="field">
            <div v-if="field==='Этапный эпикриз'">
                <div class="vm-card" v-if="listHistory[ind].data[field]!=='-'">
                    <span style="font-weight:600; margin-left:1rem"> {{field}}: </span>
                    <div v-for="epicris_field in Object.keys(listHistory[ind].data[field])"
                        v-bind:key="epicris_field"
                        style="margin-left: 1rem"
                        >
                        <span style="font-weight:600; margin-left:1rem">{{epicris_field}}:</span> <span>{{listHistory[ind].data[field][epicris_field]}}</span>
                    </div>
                </div>
                <div v-else>
                   <span style="font-weight:600; margin-left:1rem">{{field}}:</span> <span>{{listHistory[ind].data[field]}}</span>
                </div>
            </div>
            <div v-else>
                <div v-if="field==='Лекарственные препараты, физиотерапия'">
                        <span style="font-weight:600; margin-left:1rem">Лекарственные препараты, физиотерапия:</span> 
                    <div v-for="(recept, indeks) in listHistory[ind].data[field]" :key="recept.index" :index="indeks">
                        <div style="margin-left:50px" id="link-recept" tabindex="0"> <p class="recep">{{recept['Наименование лекарственного препарата']}}</p>
                            <div style="margin-left:50px">
                                <span style="font-weight:550; font-style:italic">Дозировка: </span>{{recept['Дозировка']}};
                                <span style="font-weight:550; font-style:italic">Способ применения: </span>{{recept['Способ применения']}};
                                <span style="font-weight:550; font-style:italic">Продолжительность: </span>{{recept['Продолжительность применения']}};
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="field!=='id'">
                        <span style="font-weight:600; margin-left:1rem">{{field}}:</span>  <span v-if="listHistory[ind].data[field] && listHistory[ind].data[field].length > 0">{{listHistory[ind].data[field]}}</span> <span v-else>-</span>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <div slot="body" v-if="form_value">
           <form-builder
                type="readonly"
                :form="form_data"
                v-model="form_value"
                ref="FormBuilder"
            ></form-builder>
        </div>
        <div slot="files" v-if="!form_value">
            <span style="font-weight:600; margin-left:1rem">Назначения (исследования, консультации):</span>
            <a class="fileHref" @click="downloadFile(file)" style="margin-left:1rem" v-for="file in listFileHistory" :key="file"> {{file}} </a>
        </div>
       
        <template slot="prevButton" >
            <button class="btn btn-sm btn-secondary" :disabled="ind === 0" @click="prevHistory()">
                        Предыдущая запись
                    </button>
        </template>
        <template slot="nextButton">
            <button :disabled="listHistory.length - 1 === ind"
                    class="btn btn-sm btn-secondary" @click="nextHistory()">
                        Следующая запись
                    </button>
        </template>
    </ReceptionHistory>
    <DiagnosesList v-if="isDiag" :items="help_diagnoses" @clickOutside="isDiag=false" @addItem="pushDiag" :positionLeft="DiagLeft" :positionTop="DiagTop" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { receptionApi, patientApi, dictionaryMkb10Api } from '../../../services';
import toastr from 'toastr';
import ReceptionHistory from '../components/Reception-history.vue';
import cardPatient from '../components/card-patient.vue';
import helper from '../../../services/helper';
import DiagnosesList from '@app/components/uikit/DiagnosesList.vue';

export default {
    components: {
      ReceptionHistory, cardPatient, DiagnosesList
    },
    data() {
        return {
        patient: this.$store.state.reception.current_patient,
        selected_forms: this.$route.params.selected_forms,
        other_forms: this.form_helper(),
        form_data: {},
        form_value: '',
        form_title: '',
        receptions: '',
        date: new Date().toLocaleDateString().substring(0, 10),
        primary_reception: false,
        diagnoses: [],
        dataForm: {
            type: '025/у',
            forma: {
            'Жалобы пациента': '',
            'Анамнез заболевания, жизни': '',
            'Объективные данные': '',
            'Диагноз основного заболевания': '',
            'Осложнения': '',
            'Сопутствующие заболевания': [],
            'Внешняя причина при травмах (отравлениях)': '',
            'Группа здоровья': '',
            'Диспансерное наблюдение': '',
            'Назначения (исследования, консультации)': '',
            'Лекарственные препараты, физиотерапия': ''
            },
            is_close: false
        },
            epicrisis: {
                'Жалобы и динамика состояния': '',
                'Проведенное обследование и лечение': '',
                'Диагноз основного заболевания': '',
                'Осложнения': '',
                'Сопутствующие заболевания': [],
                'Внешняя причина при травмах (отравлениях)': '',
                'Рекомендации': ''
            },
            secondary_reception: {
                'Жалобы': '',
                'Данные наблюдения в динамике': '',
                'Назначения (исследования, консультации)': '',
                'Лекарственные препараты, физиотерапия': ''
            },
            first_reception: false,
            second_is_open: false,
            isHistoryVisible: false,
            listHistory: [
                
            ],
            ind: 0,
            updown: false, bool: false,
            list_appointment: [],
            list_prescription: [],
            files: [],
            file_list: [],
            current_reception_id: '',
            listFileHistory: [],
            cardPatient: {},
            viewCardPatient: false,
            borderBottom: '',
            currentBottom: 0,
            help_diagnoses: [],
            isDiag: false,
            DiagLeft: 0,
            DiagTop: 0,
            targetValue: ''
        };
    },
    computed: { 
        ...mapGetters(['getDiagnoses']),
        ...mapGetters(['getRecepts']),
    },
    mounted() {
        if (!this.$store.state.reception.current_patient.id) {
            this.$router.push({name:'reception'});
        } else {
            const data = receptionApi.getRecord(this.$store.state.reception.current_patient.id, this.$store.state.clinic.id).then(res => {
                this.receptions = res;
                const form025 = this.findValuesForm('025/у');
                if (form025) {
                    if (form025.fields['Лекарственные препараты, физиотерапия']) {
                        this.$data.list_prescription = form025.fields['Лекарственные препараты, физиотерапия'];
                    }
                    if (form025.fields['Группа здоровья']) {
                        this.$data.dataForm.forma['Группа здоровья'] = form025.fields['Группа здоровья'];
                    }

                    if (!form025.fields.first_reception) {
                        this.$data.secondary_reception = form025.fields;
                        if (this.$data.secondary_reception['Этапный эпикриз']) {
                            this.$data.epicrisis = this.$data.secondary_reception['Этапный эпикриз'];
                            delete this.$data.secondary_reception['Этапный  эпикриз'];
                        }
                    } else {
                        this.$data.dataForm.forma = form025.fields;
                        if (this.$data.dataForm.forma['Этапный эпикриз']) {
                            this.$data.epicrisis = this.$data.dataForm.forma['Этапный эпикриз'];
                            delete this.$data.dataForm.forma['Этапный эпикриз'];
                        }
                    }


                    if (!form025.treatmentcase) {
                        this.$data.primary_reception = true;
                        this.$data.second_is_open = false;
                        this.$data.first_reception = true;
                    } else if (form025.fields.first_reception) {
                        this.$data.primary_reception = true;
                        this.$data.second_is_open = false;
                        this.$data.first_reception = true;
                    } else {
                        this.$data.first_reception = false;
                        this.$data.primary_reception = false;
                        this.$data.second_is_open = true;
                    }
                    if (form025.is_close) {
                        this.$data.dataForm.is_close = form025.is_close;
                    }
                    this.$data.current_reception_id = form025.id;
                    receptionApi.fileList(form025.id).then(fls => {
                        this.$data.file_list = fls.files;
                    });
                } else {
                    if (this.$store.state.reception.current_patient.treatmentcase && !this.$store.state.reception.current_patient.reception) {
                        this.$data.primary_reception = false;
                        this.$data.second_is_open = true;
                        this.$data.first_reception = false;
                    } else {
                        this.$data.primary_reception = true;
                        this.$data.second_is_open = false;
                        this.$data.first_reception = true;
                    }
                    if (res[0]) {
                        this.current_reception_id = res[0].id;
                    }
                }
                receptionApi.getAllRecords(this.$store.state.reception.current_patient.patient).then(response => {
                    this.$data.listHistory = response;
                     this.$data.bool = true;
                });
                patientApi.get(this.$store.state.reception.current_patient.patient).then(pat => {
                    this.cardPatient = pat;
                });                
            });
        } console.log(this.receptions);
    },
    destroyed() { 
        this.clearDiagnoses();
    },
    methods: {
        ...mapActions(['clearDiagnoses']),
        saveForm() {
           console.log(this.$refs.FormBuilder.getValue());
        },
        form_helper() {
            const mass = [];
            if (this.$route.params.selected_forms) {
                for(const form of this.$route.params.selected_forms) {
                    if (form !== 0) {
                        mass.push({value: form, opened: false, data: {}, values: ''});
                    }
                }
            } else {
                return false;
            }
            return mass;
        },
        findValuesForm(title) {
            if (this.receptions.length > 0) {
            let obj = {}; 
            const foundObj = this.receptions.find(item => item.type === title);
            if (foundObj) {
                        obj = foundObj;
                } else {
                return false;
            }
            return obj;
            } else {
                return false;
            }
        },
        openedForm(oform) {
            if (!oform.opened) {
                axios
                    .get('/api/get_latest_form/' + oform.value.id, {headers: { APIKey: this.$store.state.clinic.id}, params: {patient: this.patient.patient, doctor: this.$store.state.reception.current_patient.doctor}})
                    .then(response => {
                        oform.data = JSON.parse(response.data.form.data);
                        oform.values = this.findValuesForm(oform.value.id).fields;
                    // this.form_title = response.data.form.title;
                        oform.opened = !oform.opened;
                        if (document.getElementsByName('диагноз')[0]) {
                            setTimeout(() =>  {
                            document.getElementsByName('диагноз')[0].addEventListener('input', this.searchHelpDiagnos);
                            },500);
                        }
                    }).catch(error => {
                        toastr.error(error);
                    //console.log(error);
                    }); 
            } else {
                oform.opened = !oform.opened;
            }
        },
        searchHelpDiagnos(evt) {
            this.targetValue = evt.target.value;
            if (this.targetValue.includes(', ')) {
                this.targetValue = this.targetValue.split(', ')[this.targetValue.split(', ').length - 1];
                console.log(this.targetValue);
            }
            this.DiagLeft = document.getElementsByName('диагноз')[0].getBoundingClientRect().x;
            this.DiagTop = document.getElementsByName('диагноз')[0].getBoundingClientRect().y + document.getElementsByName('диагноз')[0].getBoundingClientRect().height;
            dictionaryMkb10Api.getAll(undefined, undefined, this.targetValue).then(res => {
                this.help_diagnoses = res.items;
                if (this.help_diagnoses.length > 0) {
                    this.isDiag = true;
                } else {
                    this.isDiag = false;
                }
            });
        },
        pushDiag(evt) {
            if (document.getElementsByName('диагноз')[0].value.includes(', ')) {
                let items = document.getElementsByName('диагноз')[0].value.split(', ');
                items[items.length - 1] = evt.MKB_NAME;
                document.getElementsByName('диагноз')[0].value = '';
                items.forEach(obj => {
                    document.getElementsByName('диагноз')[0].value += obj + ', ';
                });
                //console.log();
                //document.getElementsByName('диагноз')[0].value = document.getElementsByName('диагноз')[0].value.replace(document.getElementsByName('диагноз')[0].value.split(', ')[document.getElementsByName('диагноз')[0].value.split(', ').length - 1], evt.MKB_NAME + ', ');
            } else {
                document.getElementsByName('диагноз')[0].value = evt.MKB_NAME + ', ';
            }
            this.isDiag = false;
        },
        classAnim() {
            let clasStyle = {height: '0'};
            if (primary_reception) {
                clasStyle.height = 'auto';
            }
            return clasStyle;
        },
        chooseIllnes(str) {
            if (str.length > 2) {
                if (this.timeout) clearTimeout(this.timeout); 
                this.timeout = setTimeout(() => {
                        this.$store.dispatch('getDiagnoses', str);
                    }, 1000);
            }
        },
        chooseRecept(str) {
             if (str.length > 2) {
                if (this.timeout) clearTimeout(this.timeout); 
                this.timeout = setTimeout(() => {
                        this.$store.dispatch('getRecepts', str);
                    }, 1000);
            }
        },
        downloadFile(file) {
            let id;
            if (this.$data.isHistoryVisible) {
                id = this.$data.listHistory[this.$data.ind].id;
            } else {
                id = this.$data.current_reception_id;
            }
            receptionApi.downloadFile(file, id).then(res => {
                receptionApi.forceFileDownload(res, file);
            }).catch(err => {
                toastr.error('Файл не найден', 'Failed');
            });
        },
        openCard() {
            this.viewCardPatient = true;
        },
        submitForm(oform) {
            if (!this.$data.first_reception) {
                this.$data.secondary_reception['Группа здоровья'] = this.$data.dataForm.forma['Группа здоровья'];
                this.$data.dataForm.forma = this.$data.secondary_reception;
            } else {
                this.$data.dataForm.forma.first_reception = this.$data.first_reception;
            }
            if (this.$data.dataForm.is_close) {
                this.$data.dataForm.forma['Этапный эпикриз'] = this.$data.epicrisis;
                this.$data.dataForm.forma.first_reception = this.$data.first_reception;
            }
            this.$data.dataForm.forma['Лекарственные препараты, физиотерапия'] = this.$data.list_prescription;
            let data = {};
           // console.log(oform.values);
           let recept = null;
            if (oform && oform.values) {
                data = {
                    forma: oform.values,
                    is_close: true,
                    type: oform.value.id
                    };
            } else {
                data = this.$data.dataForm;
                recept = false;
            } console.log(data);
            let method = '';
            if (this.$store.state.reception.current_patient.reception) {
                method = 'put';
            } else {
                method = 'post';
            }
            if (oform) {
                recept = this.findValuesForm(oform.value.id);
                if (!recept) {
                    method = 'post';
                } else {
                    method = 'put';
                }
            }
            receptionApi.createRecord(data, this.$store.state.reception.current_patient.id, method).then(res => {
                toastr.info('Запись данных произведена', 'Информация');
                const cur_rec = this.findValuesForm('025/у');
               if (!this.$store.state.reception.current_patient.reception) {
                   this.$store.state.reception.current_patient.reception = res.id;
               }
               if (oform) {
                if (!recept) {
                    this.receptions.push(res);
                }
               }
               if (!cur_rec) {
                   this.receptions.push(res);
               }
                if (this.$data.files.length > 0) {
                    let formData = new FormData();
                    this.$data.files.forEach(f => {
                        formData.append(f.name, f);
                    });
                    receptionApi.uploadFiles(formData, res.id).then(f => {
                        this.$data.files = [];
                        toastr.info('Файлы загружены', 'Информация');
                    });
                }
            });
        },
        returnList() {
            this.$router.push({name:'reception'});
        },
        openVideoConf() {
            let route = this.$router.resolve({ name: 'video.appointment', params: { id: this.patient.conversation }});
            let windowFeatures = 'scrollbars=1';
            window.open(route.href, '_blank', windowFeatures);
        },
        formHistory() {
            axios
                    .get('/api/get_latest_form/' + this.listHistory[this.ind].type, {headers: { APIKey: this.$store.state.clinic.id}, params: {patient: this.patient.patient, doctor: this.$store.state.reception.current_patient.doctor}})
                    .then(response => {
                        this.form_data = JSON.parse(response.data.form.data);
                        this.form_value = this.listHistory[this.ind].data;
                    }).catch(error => {
                    //console.log(error);
                    }); 
        },
        openHistory(uuid, index) {
            this.$data.isHistoryVisible = true;
            this.$data.ind = index;
            if (this.$data.listHistory[this.$data.ind].form) {
                this.formHistory();
            }
            
        },
        prevHistory() {
            this.form_value = '';
             this.$data.ind--;
             console.log(this.listHistory[this.ind].data);
            if (this.$data.listHistory[this.$data.ind].form) {
                this.formHistory();
            }
        },
        nextHistory() {
            this.form_value = '';
            this.$data.ind++;
            if (this.$data.listHistory[this.$data.ind].form) {
                this.formHistory();
            }
        },
        reverseList() {
            this.$data.updown = !this.$data.updown;
            this.listHistory.reverse();
        },
        historyHeight() {
            if (this.$data.bool) {
            const maxHeight = document.documentElement.clientHeight; //this.$refs['asd'].clientHeight;
            return { 'max-height': maxHeight-(maxHeight*0.2) + 'px', overflow: 'auto', 'padding': '5px'};
            }
        },
        historyHeight1() {
            if (this.$data.bool) {
                const maxHeight = document.documentElement.clientHeight; // this.$refs['asd'].clientHeight;
            return { 'height': maxHeight-(maxHeight*0.2) + 'px'};
            }
        },
        disabledPrint(oform) {
        const recept = this.findValuesForm(oform.value.id);
            if (recept) {
                return false;
            } else {
                return true;
            }
        },
        print(oform) {
            const receptionID = this.findValuesForm(oform.value.id).id;
            receptionApi.printForm(receptionID).then(res => {
                if (res.result) { // 'https://docs.google.com/viewerng/viewer?url=' 
                    window.open('https://view.officeapps.live.com/op/view.aspx?src=' + process.env.VUE_APP_API_URL + res.file, '_blank');
                } else {
                    toastr.error(res.message);
                }
            });
        }
    },
    filters: {
      formDate(str) {
        if (str) {
            const date = new Date(str);
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          return date.toLocaleDateString('ru-RU', options);
        }
      }
    },
    watch: {
        ind() {
            receptionApi.fileList(this.$data.listHistory[this.$data.ind].id).then(fls => {
                this.$data.listFileHistory = fls.files;
            });
        }
    }
};
</script>

<style scoped>
    .field {
        display: flex;
        flex-flow: column-reverse;
    }
    label, textarea {
        transition: all 0.2s;
        touch-action: manipulation;
        margin-bottom: 0.1rem;
    }
    textarea:focus {
        outline: 0;
    }
    textarea:placeholder-shown + label {
        cursor: text;
        max-width: 66.66%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transform-origin: left bottom;
        transform: translate(0, 2.125rem) scale(1.5);
    }
    ::-webkit-textarea-placeholder {
         opacity: 0;
         transition: inherit;
    }
    textarea:focus::-webkit-textarea-placeholder {
        opacity: 1;
    }

    textarea:not(:placeholder-shown) + label,
    textarea:focus + label {
        transform: translate(0, 0) scale(1);
        cursor: pointer;
    }

    .vm-card {
        width:auto; display:flex; 
        justify-content:center; 
        padding:1rem; 
        flex-direction: column; 
        margin-bottom: 0.5rem;
        margin-top: 0.5rem;
    }

    #toggled{

	overflow: hidden;
	max-height: 0px;
	transition: max-height 1s cubic-bezier(0, 1, 0, 1) -.1s;
}

    #toggled.anim {
        max-height: 9999px;
        transition-timing-function: cubic-bezier(0.5, 0, 1, 0); 
        transition-delay: 0s;
    }
    .non {
        height: 0px;
    }

    .list-group-item:hover {
        cursor: pointer;
        background: linear-gradient(to bottom right, #b7e1f3, #e4f0f5);
    }

    .vm-icon-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 0;
  background-color: transparent;
  outline: none;
  background: transparent;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  margin: 2px;
}
.vm-icon-button:focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.vm-icon-button i {
  color: #969696;
  font-size: 20px;
}
h2 {
    /*font-family: Proxima Nova; */
    font-style: normal;
    font-weight: bold;
    line-height: 42px;
    /* identical to box height */
    color: #36234D;
}

.gray_field {
    background: white;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
   /* font-family: Proxima Nova; */
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 23px;
    color: #36234D;
    padding-top: 5px;
    padding-bottom: 5px;
}

.descr {
    background: linear-gradient(to right, #8C30DA, #5C48D4);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size:12px;
}

.v-select {
    margin-bottom: 0;
}
p {
    margin-bottom: 0;
}
.list-history {
    text-align:center; 
    border-radius:10px; 
    margin-bottom:10px; 
    padding: 2px 0 2px 0;
    color:white; 
    opacity:0.6;
    background: linear-gradient(to right, #8C30DA, #5C48D4);
    cursor: pointer;
    filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
}
.list-history:hover {
    opacity: 1;
}
.backInp {
    position: relative;
    left: 10px;
    align-self: center;
    width: 1px;
    margin-top: 5px;
    word-wrap: normal !important;
}
a.fileHref {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
}
a.fileHref:hover {
    color: #0056b3;
    text-decoration: underline;
}

.recep {
    cursor: pointer;
}
.recep:hover {
    color: cornflowerblue;
    z-index: 9999;
}
.tooltip {
    position: fixed;
}

.card {
    padding: 10px;
    margin-top:15px;
}

</style>